import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import Illustration from "../../../../partials/content/Illustration";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import {
  getDiscounts,
  deleteDiscount,
} from "../../../../services/sales/discountService";
import { Badge } from "react-bootstrap";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function DiscountList({ history }) {
  const { reload } = useGlobalData();
  const [discounts, setDiscounts] = useState([]);
  const [auth, setAuth] = useState({ create: false });
  const discountPromoDetailColumn = [
    {
      header: "Minimum Purchase Requirement",
      field: "minPurchaseTypeName",
      type: "string",
    },
    {
      header: "Max Discount Use (0 unlimited)",
      field: "maxDiscountUse",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
  ];
  actionButtons.push({
    title: "New Discount",
    color: "primary",
    icon: "fas fa-plus-circle",
    onClick: () => {
      history.push("/sales/discount/discount-form/0");
    },
  });
  useEffect(() => {
    getDiscountData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Discount List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/discount/discount-list",
            title: "Discounts",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        {discounts.length ? (
          <CustomDataTable
            data={discounts}
            dataDetailColumns={discountPromoDetailColumn}
            onRefreshData={() => {
              getDiscountData();
            }}
            tableName="discount"
            selectionMode="checkbox"
            columns={[
              {
                selectionMode: "multiple",
              },
              {
                header: "Discount ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Discount Code",
                field: "discountCode",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.discountCode}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Discount Name",
                field: "discountName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.discountName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Start Date",
                field: "startDate",
                body: (rowData) => formatDate(rowData.startDate),
                sortable: true,
                filter: true,
              },
              {
                header: "End Date",
                field: "endDate",
                body: (rowData) => formatDate(rowData.endDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Discount Status",
                field: "discountStatus",
                body: (rowData) => {
                  if (rowData.discountStatus === 2) {
                    return (
                      <Badge variant="danger">
                        {rowData.discountStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.discountStatus === 1) {
                    return (
                      <Badge variant="success">
                        {rowData.discountStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.discountStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Discount Type",
                field: "discountTypeName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Edit Discount">
                      <button
                        type="button"
                        onClick={(event) => {
                          history.push(
                            `/sales/discount/discount-form/${rowData.ID}`
                          );
                        }}
                        className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Discount Detail">
                      <button
                        type="button"
                        onClick={(event) => {
                          history.push(
                            `/sales/discount/discount-detail/${rowData.ID}`
                          );
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete Discount">
                      <button
                        type="button"
                        onClick={() => handleDeleteDiscount(rowData.ID)}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Sales.png"
            description="Hooray! You're ready to have your first Discount!"
            guidance='Hint: setup the sale discounts such as "Buy X Get Y", "Price Discount", etc.'
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
    </React.Fragment>
  );

  async function handleDeleteDiscount(discountID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Discount ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteDiscount(discountID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getDiscountData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getDiscountData() {
    const response = await getDiscounts();
    const { data, auth } = response.data;
    setAuth(auth);
    setDiscounts(data.discounts);
  }
}

export default DiscountList;
